import { css } from '@emotion/react';

export const MYPAGE_MOBILE_BP = '1180px';

/** 모달 헤더와 중복되는 페이지 h2 제목 */
export const mypageSubPageTitleCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		display: none;
	}
`;

export const mypageFormContainerCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		gap: 2rem;
		max-width: none;
		width: 100%;
		margin: 0;

		& > button[type='submit'] {
			width: 100%;
		}
	}
`;

export const mypageSubPageContainerCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		gap: 1.6rem;
		max-width: none;
		width: 100%;
		margin: 0;
	}
`;

export const mypageFieldBoxCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		gap: 1.6rem;
	}
`;

export const mypageSubmitAreaCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		width: 100%;

		button {
			width: 100%;
		}
	}
`;

export const mypageFlexRowMobileCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		flex-wrap: wrap;
		height: auto;
		min-height: 4.4rem;
	}
`;

export const mypageGenderBoxMobileCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		gap: 2rem;
	}
`;
